'use client'

import isClient from '@/utils/browser/isClient'
import useMediaQuery from '@/utils/browser/getDeviceScreen'

import { Pagination, Autoplay } from 'swiper/modules'

import { TRAININGS } from './constants'

const useTypesTrainingNew = () => {
  const isMobile = useMediaQuery('mobile')
  const isDesktop = useMediaQuery('desktopMid')
  const isDesktopLarge = useMediaQuery('desktopLarge')

  const settings = {
    slidesPerView:
      isClient() && !isMobile
        ? !isDesktop
          ? 2.2
          : isDesktopLarge
            ? 4.2
            : 3.2
        : 1.2,
    spaceBetween: 16,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 2200,
      disableOnInteraction: false
    },
    speed: 1800,
    pagination: {
      clickable: true
    },
    modules: [Pagination, Autoplay]
  }

  return {
    TRAININGS,
    settings,
    isMobile
  }
}

export default useTypesTrainingNew
